import React, { useState } from "react";

import {
	FormTab,
	ImageInput,
	ImageField,
	ReferenceInput,
	SelectInput,
	TabbedForm,
	TextInput,
	required,
	useChoicesContext,
} from "react-admin";
import RichTextInput from "../../fields/RichTextInput";
import { SelectChallengeStatusInput } from "../../fields/SelectChallengeStatus";
import { UploadOrUrlImageInput } from "../../fields/UploadOrUrlImage";

const ChallengeCreatorSelectInput = (props) => {
	const { allChoices } = useChoicesContext(props);

	const choices = allChoices.map((v) => {
		// noinspection JSUnresolvedVariable
		return { id: v.id, name: `${v.firstname} ${v.lastname}` };
	});

	return <SelectInput {...props} source="user_id" choices={choices} />;
};

const ChallengeForm = (props) => {
	return (
		<TabbedForm {...props}>
			<FormTab label="Résumé pour liste">
				<TextInput
					fullWidth
					multiline
					source="abstract_title"
					label="Titre"
					validate={required()}
				/>
				<UploadOrUrlImageInput fullWidth source="abstract_image" label="Image" required />
				<TextInput
					multiline
					fullWidth
					source="abstract_content"
					label="Texte"
					validate={required()}
				/>
			</FormTab>

			<FormTab label="Contenu">
				<TextInput fullWidth source="title" label="Titre" />
				<TextInput fullWidth source="subtitle" label="Sous titre" />
				<RichTextInput source="content" label="Contenu visible" />
				<RichTextInput source="content_more" label="Contenu en savoir plus" />
				<UploadOrUrlImageInput fullWidth source="background_image" label="Image" required />
				<TextInput fullWidth source="copyright" label="Copyright" />
			</FormTab>

			<FormTab label="Configuration">
				<TextInput fullWidth source="url" label="URL de la page" />
				<TextInput fullWidth source="meta_title" label="Titre pour le SEO" />
				<TextInput source="origin_code" label="Code origine" />
				<SelectChallengeStatusInput source="status" label="Statut" />
				<ReferenceInput source="user_id" reference="user">
					<ChallengeCreatorSelectInput label="Créateur" />
					{/*<SelectInput optionText="id"/>*/}
				</ReferenceInput>
				<TextInput fullWidth source="entity_logo" label="Logo Partenaire" />
				<UploadOrUrlImageInput fullWidth source="entity_logo" label="Image" />
			</FormTab>
		</TabbedForm>
	);
};

export default ChallengeForm;
